import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {TranslateModule} from '../../translate-module';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import {CompanyService} from '../../services/company.service';
import { AppDataService } from '../../services';
import { PainelFinanceiroComponent } from './painel-financeiro.component';

@NgModule({
  declarations: [
PainelFinanceiroComponent

  ],
  imports: [
    BrowserModule,
    HttpModule,
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,

    BrowserModule.withServerTransition({
      appId: 'angular-universal-firebase'
    }),


  ],
  providers: [
    CompanyService,
    AppDataService


  ],
  exports: [
    PainelFinanceiroComponent
    ]
})
export class PainelFinanceiroModule { }



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/painel-financeiro/painel-financeiro.module.ts